import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'Yo no sabía ni prender bien el Air Fryer y en la primera semana ya había hecho 5 recetas distintas. Mi marido no podía creer que era keto.',
    name: 'María L.',
    location: 'Córdoba'
  }, {
    text: 'En 10 días bajé 2 kilos y ya no siento esa hinchazón de después de comer. Lo mejor es que cocino en 15 minutos.',
    name: 'Carolina S.',
    location: 'CABA'
  }, {
    text: 'Tengo diabetes tipo 2 y mi médico me felicitó por los valores de la última analítica. Le dije que empecé keto con Air Fryer y me pidió las recetas.',
    name: 'Patricia R.',
    location: 'Rosario'
  }, {
    text: 'Bajé 4 kilos en las dos primeras semanas. Lo mejor fue que no pasé hambre ningún día. Los snacks me salvaron las tardes. El bono de untables es un plus enorme.',
    name: 'Valentina A.',
    location: 'Santa Fe'
  }, {
    text: 'Trabajo todo el día y tengo poco tiempo. Estas recetas son en serio rápidas. El plan de 14 días me ordenó la semana y dejé de improvisar. Recomendable 100%.',
    name: 'Natalia M.',
    location: 'Chaco'
  }, {
    text: 'Hice mil dietas y siempre las abandoné. Esta es la primera vez que llego a la segunda semana sin haberlo dejado. El brownie keto del Air Fryer es una locura de rico.',
    name: 'Laura C.',
    location: 'La Plata'
  }];
  return <section className="bg-white py-16 px-4 md:py-24" data-id="element-276">
      <div className="max-w-[1000px] mx-auto" data-id="element-277">
        <div className="text-center mb-12" data-id="element-278">
          <div className="inline-block bg-gray-100 text-gray-800 font-bold text-xs px-4 py-1.5 rounded-full mb-4" data-id="element-279">
            👥 TESTIMONIOS
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-gray-900" data-id="element-280">
            Resultados reales de personas que{' '}
            <span className="text-[#00A86B]" data-id="element-281">ya lo tienen</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-282">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-[#F5F5F5] p-6 rounded-2xl flex flex-col h-full" data-id="element-283">
              <div className="flex text-[#F59E0B] mb-4" data-id="element-284">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-285" />)}
              </div>
              <p className="text-gray-600 italic text-sm leading-relaxed mb-6 flex-1" data-id="element-286">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-287">
                <div className="w-10 h-10 rounded-full bg-[#00A86B]/20 flex items-center justify-center text-[#00A86B] font-bold" data-id="element-288">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-289">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-290">{t.name}</p>
                  <p className="text-gray-500 text-xs" data-id="element-291">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}